import { render, staticRenderFns } from "./IntegrationFormFields.vue?vue&type=template&id=f774af0a&scoped=true"
import script from "./IntegrationFormFields.vue?vue&type=script&lang=js"
export * from "./IntegrationFormFields.vue?vue&type=script&lang=js"
import style0 from "./IntegrationFormFields.vue?vue&type=style&index=0&id=f774af0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f774af0a",
  null
  
)

export default component.exports